webpackJsonp([21,35],{

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(165),
	  /* template */
	  __webpack_require__(228),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    total: {
	      default: 0
	    },
	
	    price: {
	      default: 0
	    },
	    unit: {
	      default: '¥'
	    },
	    icon: {
	      default: 'gouwuche'
	    },
	    btnText: {
	      default: '去结算'
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	  attached: function attached() {},
	
	  methods: {
	    handleClick: function handleClick() {
	      this.$emit('on-click', this);
	    }
	  },
	  components: {}
	};

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shoppingBar = __webpack_require__(219);
	
	var _shoppingBar2 = _interopRequireDefault(_shoppingBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  ready: function ready() {},
	  attached: function attached() {},
	
	  methods: {
	    onclick: function onclick() {
	      this.$toast.open('去结算');
	    }
	  },
	  components: {
	    shoppingBar: _shoppingBar2.default
	  }
	};

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(101);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  extends: _core2.default,
	  components: {}
	};

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(166),
	  /* template */
	  __webpack_require__(253),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 228:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "layout-bottom"
	  }, [_c('shopping-bar', {
	    attrs: {
	      "icon": "present",
	      "price": "123.4",
	      "total": "10"
	    },
	    on: {
	      "on-click": _vm.onclick
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "shopping-bar flex-box"
	  }, [_c('div', {
	    staticClass: "icon iconfont",
	    class: [("icon-" + _vm.icon)]
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex-item-1 tl shopping-info"
	  }, [_c('div', {
	    staticClass: "bar-price font-strong"
	  }, [_c('span', {
	    staticClass: "font-sm color-highlight"
	  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('span', {
	    staticClass: "font-md color-highlight"
	  }, [_vm._v(_vm._s(_vm.price))])]), _vm._v(" "), _c('div', {
	    staticClass: "font-light font-sm bar-total"
	  }, [_vm._v("共计" + _vm._s(_vm.total) + "件")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex-item"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-lg",
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.btnText) + "\n    ")])])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/21.812f43872a7208855732.js